const router = [
  {
    path: "/kelola/instansi/:instansi_id/informasi",
    name: "informasi",
    meta: {
      auth: true,
      module: "Kelola Informasi"
    },
    component: () => import("./pages/List.vue")
  },
  {
    path: "/kelola/informasi/:informasi_id",
    name: "informasi.detail",
    meta: {
      module: "Detail Informasi",
      auth: true
    },
    component: () => import("./pages/Detail.vue")
  }
];

export default router;
